/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable import/no-cycle */
/* eslint-disable-next-line react/jsx-props-no-spreading */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter,
  ColumnChooser,
  Resize,
} from '@syncfusion/ej2-react-grids';
import { useNavigate } from 'react-router-dom';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { useStateContext } from '../contexts/ContextProvider';

import { notificationsGrid } from '../data/dummy';
import { Header } from '../components';
import './Zackat.css';

const NotificationEvents = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=notificationevents');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { zRenderMode, isMobile, setNotificationDevice } = useStateContext();

  let grid = useRef(null);
  const details = { text: 'Ack', tooltipText: 'Acknowledge ', prefixIcon: 'e-expand', id: 'ack' };
  const nack = { text: 'NACK', tooltipText: 'Negative Acknowledge ', prefixIcon: 'e-delete-row', id: 'nack' };
  const toolbarOptions = ['Search', details, nack];
  const { REACT_APP_API_ENDPOINT } = process.env;

  const editing = { allowDeleting: false, allowEditing: false };
  const [ack, setAck] = useState([]);
  const [ackReasons, setAckReasons] = useState([]);
  const [nackReasons, setNackReasons] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = '10000';
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/notifications?${query}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // set state when the data received
          setData(mydata);
          const myacks = [];
          const mynacks = [];
          mydata.notificationReasons.forEach((reason) => {
            if (reason.category === 'ack') {
              myacks.push({ value: reason._id, text: reason.text });
            } else if (reason.category === 'nack') {
              mynacks.push({ value: reason._id, text: reason.text });
            }
          });
          setAckReasons(myacks);
          setNackReasons(mynacks);
          setLoading(false);
        })
        .catch(() => {
        });
    };
    dataFetch();
  }, [ack]);
  // Action handler for the button
  const actionHandler = (args) => {
    if (args.device) {
      localStorage.setItem('currentAssociate', args.name);
      setNotificationDevice(args.name);

      navigate('/associatelayout'); // ?id=${args.associateid}&name=${args.name}`);
    }
  };

  // Template function to render the button
  const buttonTemplate = (props) => (
    <ButtonComponent
      cssClass="e-icons e-user e-round"
      onClick={() => actionHandler(props)}
    />
  );
  const boxPad = isMobile ? '16px' : '24px';
  const boxFont = isMobile ? '1rem' : '1.25rem';
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
    gap: isMobile ? '12px' : '16px',
    padding: isMobile ? '12px' : '16px',
  };

  const boxStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    padding: boxPad,
    textAlign: 'center',
    borderRadius: '8px',
    fontSize: boxFont,
    minWidth: 0,
  };

  const wrapAdaptiveGrid = (gridEl) => {
    if (!gridEl) {
      return null;
    }
    return (
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            {gridEl}
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return <p>Loading... </p>;
  }
  let dialogInstance;
  let dropdownObj;
  const dialogWidth = isMobile ? '95%' : '400px';

  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'Ack') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select at least one notification to acknowledge!');
        args.cancel = true;
        return;
      }
      // Create container and dropdown markup
      const container = document.createElement('div');
      const msg = document.createElement('p');
      msg.innerText = `Acknowledge ${selectedRecords.length} Notification(s)?\n\nPlease select a reason below:\n\n`;
      const dropElem = document.createElement('input');

      container.appendChild(msg);
      container.appendChild(dropElem);

      dialogInstance = DialogUtility.confirm({
        title: 'Ack Alerts/Notifications',
        content: container,
        width: dialogWidth,
        okButton: { text: 'OK',
          click: () => {
            const notifications = [];
            const user = { user: usr };
            notifications.notifications = selectedRecords;
            // Get selected value from dropdown instance
            const reason = dropdownObj ? dropdownObj.value : null;
            if (reason.length === 0) {
              return;
            }
            const output = { ...user, ...notifications, reason };

            dialogInstance.hide();
            fetch(`${REACT_APP_API_ENDPOINT}/notifications`, {
              method: 'UPDATE',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `JWTToken ${usr.token}`,
              },
              body: JSON.stringify(output),
            })
              .then((response) => response.json())
              .then((responseJson) => {
                // The added/edited data will be saved in the Grid
                if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                  DialogUtility.alert(responseJson.response);
                }
                setAck(!ack);
              })
              .catch(() => {
              });
          },
          cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
          showCloseIcon: true,
          closeOnEscape: true,
          isModal: true,
          animationSettings: { effect: 'Zoom' },
        },
      });
      // Initialize DropDownList after element is available / in DOM context
      dropdownObj = new DropDownList({
        dataSource: ackReasons,
        placeholder: 'Select a value',
        value: 'Heat',
      });
      dropdownObj.appendTo(dropElem);
    } else if (grid && args.item.properties.text === 'NACK') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select at least one notification to clear as a non event!');
        args.cancel = true;
        return;
      }

      // Create container and dropdown markup
      const container = document.createElement('div');
      const msg = document.createElement('p');
      msg.innerText = `Clear ${selectedRecords.length} Notification(s)?\n\nPlease select an reason below:\n\n`;
      const dropElem = document.createElement('input');

      container.appendChild(msg);
      container.appendChild(dropElem);
      dialogInstance = DialogUtility.confirm({
        title: 'Negative Acknoledge Alerts/Notifications',
        content: container,
        width: dialogWidth,
        okButton: { text: 'OK',
          click: () => {
            const notifications = [];
            const user = { user: usr };
            notifications.notifications = selectedRecords;
            // Get selected value from dropdown instance
            const reason = dropdownObj ? dropdownObj.value : null;
            const output = { ...user, ...notifications, reason };
            dialogInstance.hide();

            fetch(`${REACT_APP_API_ENDPOINT}/notifications?nack=true`, {
              method: 'UPDATE',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `JWTToken ${usr.token}`,
              },
              body: JSON.stringify(output),
            })
              .then((response) => response.json())
              .then((responseJson) => {
                // The added/edited data will be saved in the Grid
                if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                  DialogUtility.alert(responseJson.response);
                }
                setAck(!ack);
              })
              .catch(() => {
              });
          },
        },
        cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
        showCloseIcon: true,
        closeOnEscape: true,
        isModal: true,
        animationSettings: { effect: 'Zoom' },
      });
      // Initialize DropDownList after element is available / in DOM context
      dropdownObj = new DropDownList({
        dataSource: nackReasons,
        placeholder: 'Select a value',
        value: 'Undetermined',
      });
      dropdownObj.appendTo(dropElem);
    }
  };
  const FilterOptions = {
    type: 'Menu',
  };
  return (
    <div className={!isMobile ? 'm-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh max-w-full overflow-x-hidden' : 'bg-white rounded-3xl zackat-divalh w-full mt-44 max-w-full overflow-x-hidden'}>
      <Header category="Operations" title={`Total Active Notification Events ( ${data.notifications ? data.notifications.length : 0} )`} />
      <div style={containerStyle}>
        <div style={boxStyle}>{data.results && data.results.totalNotifications && data.results.totalNotifications.toLocaleString('en-US')} 🛎 (safety notifications for {new Date().getFullYear()})</div>
        <div style={boxStyle}>{data.results && data.results.ackNotifications && data.results.totalNotifications && ((data.results.totalHeat / data.results.totalNotifications) * 100).toFixed(0)}% ⚠ (heat related stress events)</div>
        <div style={boxStyle}>{data.results && data.results.ackNotifications && data.results.totalNotifications && ((data.results.ackNotifications / data.results.totalNotifications) * 100).toFixed(0) }% &#x2406; (intervention acknowledgement rate)</div>
        <div style={boxStyle}>{data.results && data.results.totalEvents && data.results.totalEvents.toLocaleString('en-US')} ⌖ (environmental sensor readings collected)</div>
      </div>
      {wrapAdaptiveGrid(
        <GridComponent
          dataSource={data.notifications}
          id="gridnotifications"
          width="100%"
          allowPaging
          allowSorting
          toolbarClick={clickHandler}
          editSettings={editing}
          toolbar={toolbarOptions}
          enableHover={false}
          pageSettings={isMobile ? { pageSize: 20, pageCount: 3 } : { pageSize: 100, pageCount: 10 }}
          allowResizing
          // allowFiltering={data && data.length > 0}
          // filterSettings={FilterOptions}
          // showColumnChooser
          allowTextWrap
          ref={(g) => { grid = g; }}
          enableAdaptiveUI={isMobile}
          rowRenderingMode={zRenderMode}
          enableAltRow
          enableStickyHeader={!isMobile}
          enablePersistence={false}
        >
          <ColumnsDirective>
            <ColumnDirective
              field="_id"
              headerText="ID"
              width="100"
              isPrimaryKey
              visible={false}
            />
            <ColumnDirective
              type="checkbox"
              width="50"
            />
            <ColumnDirective
              field="device"
              headerText="Name"
              width="150"
              textAlign="Left"
              visible
              template={buttonTemplate}
            />
            {notificationsGrid.map((item, index) => (
              <ColumnDirective
                key={index}
                {...item}
                {...(item.field === 'desc') && isMobile ? { visible: false } : {}}
              />
            ))}
          </ColumnsDirective>
          <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize]} />
        </GridComponent>,
      )}
    </div>
  );
};
export default NotificationEvents;
